import React from 'react';
import { Alert, Button, Space } from 'antd';
import Connector from "../../../redux/connector";
import {GetUserToken} from "../../../api/token";

class ReminderMe extends React.Component{
    constructor(props) {
        super(props);
    }
    hasNotification=()=>{
        if(this.getNumberDue()===0){
            return false;
        }
        return true;
    }
    goDetail=()=>{
        window.location.href="#/workboard-view-reminder";
        window.location.reload();
    }
    getNumberDue=()=>{
        let user = GetUserToken();
        let num=0;
        const reminders = this.props.reminder.Reminders;

        for(let i in reminders){
            const row = reminders[i];
            if(row.state ==="complete"){continue}
            console.log("getNumberDue > | ",user.Org," > ",row.org," >> ",user.Org !==row.org);
            if(user.Org !==row.org){continue}

            num++;
        }
        return num;
    }

    render() {
        if(!this.hasNotification()){
            return null
        }
        return (
            <div style={styles.container}>
                <Alert
                    style={{
                        minWidth:"50%",
                        maxWidth:"50%",
                       /* float:"right",*/
                        marginRight:10,
                    }}
                    message="Reminder Notification"
                    description={"You have "+this.getNumberDue()+" due reminder(s) in your box, please acknowledge it!"}
                    type="info"
                    action={
                        <Space direction="vertical">
                            <Button size="small" type="primary" onClick={()=>this.goDetail()}>
                                Detail
                            </Button>
                            {/*<Button size="small" danger type="ghost">
                                Decline
                            </Button>*/}
                        </Space>
                    }
                    closable
                />
            </div>
        )
    }

}

export default Connector(ReminderMe);

const styles={
    container:{
        position:"absolute",
        float:"right",
        marginTop:-30,
        marginRight:50,
        zIndex:100,
        minWidth:"75%",
        maxWidth:"75%",
        maxHeight:110,
        minHeight:110,
        justifyContent:"flex-end",
        alignItems:"center",
        display:"flex",
        /*backgroundColor:"black"*/
    }
}
